import { Component, HostListener, OnInit } from '@angular/core';
import {PageService} from "../../service/page/page.service";
import * as Swiper from "swiper";
import {PageSpaceBannerItem, PageSpaceFloorItem} from "../../service/page/page";

@Component({
  selector: 'app-seongsu-space',
  templateUrl: 'space.component.html',
  styleUrls: ['space.component.scss'],
  providers: [PageService]
})

export class SeongsuSpaceComponent implements OnInit {
  innerWidth: number = 0;
  isMobile: boolean = false;
  location = 'seongsu';
  latitude: number = 37.5443931;
  longitude: number = 127.04772120000007;
  config = {
    scrollbar: null,
    direction: 'horizontal',
    slidesPerView: 1,
    scrollbarHide: false,
    keyboardControl: false,
    mousewheelControl: false,
    scrollbarDraggable: true,
    scrollbarSnapOnRelease: true,
    nextButton: '.swiper-button-next',
    prevButton: '.swiper-button-prev',
    autoplayStopOnLast: false,
    autoplayDisableOnInteraction: false,
    watchSlidesProgress: true,
    watchSlidesVisibility: true,
    autoplay: 300000,
    loop: true,
    pagination: '.swiper-pagination',
    paginationType: 'bullets',
    paginationClickable: true,
  };
  swiper;

  banners: PageSpaceBannerItem[];
  floors: PageSpaceFloorItem[];

  constructor(private pageService: PageService,) { }

  async ngOnInit() {
    this.isMobile = (window.innerWidth < 768);
    this.innerWidth = window.innerWidth;
    this.swiper = new Swiper('.swiper-container-banner', this.config);
    this.banners = (await this.pageService.getSpaceBanner(this.location)).banners;
    this.floors = (await this.pageService.getSpaceFloorInfo(this.location)).floorGuides;

    // this.onCarouselInit();
  }

  onCarouselInit() {
    if(this.banners.length === 1) {
      document.querySelector('.swiper-container-banner').classList.add('one-contents')
      this.swiper.params.loop = false
    } else {
      document.querySelector('.swiper-container-banner').classList.remove('one-contents')
      this.swiper.params.loop = true
    }

    this.swiper.removeAllSlides();
    this.swiper.appendSlide(this.banners.map(
      bannner => `
        <div class="swiper-slide" style="background-image:url('${this.isMobile ? bannner.mobileImage : bannner.image}')">
          <div class="wrapper office-space">
            <h3 class="slider-title" i18n>${bannner.title}</h3>
            <div class="slider-desc">${bannner.description}</div>
          </div>
        </div>
    `));
    this.swiper.update(true);
    this.swiper.slideTo(1, 0);
  }

  @HostListener('window:resize', ['$event']) onResize(event) {
    this.innerWidth = event.target.innerWidth;
    let isMobile = (event.target.innerWidth < 768);
    if (this.isMobile != isMobile) {
      this.isMobile = isMobile;
      // this.onCarouselInit();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/seongsu/space/space.component.ts